// useEventConfig (admin) — subscribe to /config/event for the active cohortId.
//
// Admin-side mirror of the user app's useEventConfig. Returns the cohortId
// that the admin is currently managing (used by AudioRelease to decide which
// cohortReleased / cohortReleasedAt fields to write).
//
// Fail-open: if the doc is missing or Firestore errors, defaults to "2025"
// so an uninitialised /config/event never silently causes wrong-cohort writes
// (admin sees a loading splash until confirmed).

import { configEventDoc, useFirestoreDoc } from "@goodbye/firebase";
import type { ConfigEventDoc } from "@goodbye/firebase";

export interface AdminEventConfigState {
  /** Active cohort for release decisions, e.g. "2025" / "2026". */
  cohortId: string;
  loading: boolean;
}

export function useEventConfig(): AdminEventConfigState {
  const snap = useFirestoreDoc<ConfigEventDoc>(configEventDoc());

  if (snap.loading) return { cohortId: "2025", loading: true };
  if (snap.error || !snap.data) return { cohortId: "2025", loading: false };
  return {
    cohortId: snap.data.cohortId ?? "2025",
    loading: false,
  };
}
